import {
    NAME_CHANGE,
    PHONE_CHANGE,
    EMAIL_CHANGE,
    POSITION_CHANGE,
    LAST_CHANGE,
    SET_CUSTOMER,
    ERASE_CUSTOMER_CONTACT,
} from './constants';

const defaultState = {
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    position: '',
};

const contactUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CUSTOMER:
            return {
                firstName: action.customer.firstName,
                lastName: action.customer.lastName,
                phone: action.customer.phone,
                email: action.customer.email,
                position: action.customer.position,
            };
        case ERASE_CUSTOMER_CONTACT:
            return {
                firstName: null,
                lastName: null,
                phone: null,
                email: null,
                position: null,
            };

        case NAME_CHANGE:
            return { ...state, firstName: action.firstName };

        case LAST_CHANGE:
            return { ...state, lastName: action.lastName };

        case PHONE_CHANGE:
            return { ...state, phone: action.phone };

        case EMAIL_CHANGE:
            return { ...state, email: action.email };

        case POSITION_CHANGE:
            return { ...state, position: action.position };


        default:
            return state;
    }
};

export default contactUI;



// WEBPACK FOOTER //
// ./src/containers/AddClient/Contact/reducer.js